module.exports = __webpack_public_path__ + "img/logo-dark.efd38b77.svg";